export default {
    methods: {
        getMimeTypes() {
            return ({
                jpg: "image/jpeg",
                jpeg: "image/jpeg",
                png: "image/png",
                gif: "image/gif",
                bmp: "image/bmp",
                webp: "image/webp",
                svg: "image/svg+xml",
                tiff: "image/tiff",
                tif: "image/tiff",
                ico: "image/vnd.microsoft.icon",
                heic: "image/heic",
                avif: "image/avif"
            })
        }
    }
}